import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { CakeItEasyWebUiModule } from '@cakeiteasy/web-ui';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';

import { SharedModule } from '../shared/shared.module';

import { ProductCardComponent } from './components/product-card/product-card.component';
import { ProductImageComponent } from './components/product-image/product-image.component';
import { ProductPriceComponent } from './components/product-price/product-price.component';
import { ProductHeaderComponent } from './components/product-header/product-header.component';
import { ChosenOptionsComponent } from './components/chosen-options/chosen-options.component';
import {
  ProductAllergensComponent
} from './components/product-allergens/product-allergens.component';
import {
  ProductDescriptionComponent
} from './components/product-description/product-description.component';
import {
  MenuChosenProductsComponent
} from './components/menu-chosen-products/menu-chosen-products.component';
import { ProductCounterComponent } from './components/product-counter/product-counter.component';
import {
  CateringMenuTypeComponent
} from './components/catering-menu-type/catering-menu-type.component';
import {
  SinglePieceTypeComponent
} from './components/single-piece-type/single-piece-type.component';
import { ComplexTypeComponent } from './components/complex-type/complex-type.component';
import {
  PiecesGroupTypeComponent
} from './components/pieces-group-type/pieces-group-type.component';
import {
  ProductTypeListComponent
} from './components/product-type-list/product-type-list.component';
import {
  ProductDescriptionSliceComponent
} from './components/product-description-slice/product-description-slice.component';
import { RequestFormTypeComponent } from './components/request-form-type/request-form-type.component';
import {
  ProductCartActionsComponent
} from './components/product-cart-actions/product-cart-actions.component';



@NgModule({
  declarations: [
    ProductCardComponent,
    ProductImageComponent,
    ProductHeaderComponent,
    ChosenOptionsComponent,
    ProductAllergensComponent,
    ProductDescriptionComponent,
    MenuChosenProductsComponent,
    ProductCounterComponent,
    CateringMenuTypeComponent,
    SinglePieceTypeComponent,
    ComplexTypeComponent,
    PiecesGroupTypeComponent,
    ProductTypeListComponent,
    ProductDescriptionSliceComponent,
    RequestFormTypeComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    CakeItEasyWebUiModule,
    SharedModule,
    NgCakeItEasyUtilsModule,
    ProductPriceComponent,
    ProductCartActionsComponent,
  ],
  exports: [
    ProductTypeListComponent,
  ]
})
export class ProductsListModule {}
